import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

export const VEHICLE_VALUATION_VEHICLE_SELECTION_OPERATION = "vehicle-selection" as const;
export const VEHICLE_VALUATION_VEHICLE_SELECTION_API_PATH =
  `/v1/${VEHICLE_VALUATION_RESOURCE}/{uuid}/${VEHICLE_VALUATION_VEHICLE_SELECTION_OPERATION}` as const;

export type VehicleValuationVehicleSelectionResponse =
  paths[typeof VEHICLE_VALUATION_VEHICLE_SELECTION_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleValuationVehicleSelectionQuery(uuid: string) {
  return useQuery({
    enabled: Boolean(uuid),
    queryKey: [VEHICLE_VALUATION_RESOURCE, uuid, VEHICLE_VALUATION_VEHICLE_SELECTION_OPERATION],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<VehicleValuationVehicleSelectionResponse>(
        `/v1/${VEHICLE_VALUATION_RESOURCE}/${uuid}/${VEHICLE_VALUATION_VEHICLE_SELECTION_OPERATION}`,
      );

      return response.data;
    },
  });
}
